import React from 'react';

import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import { FunctionalRootState, getPreferenceFileUrlFromAccount, getPreferenceFromAccount } from '@share/utils';
import { ILoginState } from '@share/store/slices';
import { BANNER_PRIMARY_PHOTO_FIELD_KEY, BANNER_PRIMARY_PHOTO_URL_FIELD_KEY, BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY, BANNER_SEARCH_RESULT_PHOTO_URL_FIELD_KEY, BANNER_SECONDARY_PHOTO_FIELD_KEY, BANNER_SECONDARY_PHOTO_URL_FIELD_KEY, PRIMARY_BANNER_TYPE, SEARCH_BANNER_TYPE, SECONDARY_BANNER_TYPE } from '@share/common-types';

import './style.scss';

interface IProps {
  type: string;
}

export function Banner(props: IProps) {

  const anchorRef: React.RefObject<HTMLAnchorElement> = React.createRef();

  const loginStore: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);

  const { type } = props;
  const { account } = loginStore;

  const handleClick = () => {
    const keyPhotoUrl = type === PRIMARY_BANNER_TYPE ? BANNER_PRIMARY_PHOTO_URL_FIELD_KEY :
                        type === SECONDARY_BANNER_TYPE ? BANNER_SECONDARY_PHOTO_URL_FIELD_KEY :
                        type === SEARCH_BANNER_TYPE ? BANNER_SEARCH_RESULT_PHOTO_URL_FIELD_KEY : null;
                        
    const imageUrl = keyPhotoUrl ? getPreferenceFromAccount(account, keyPhotoUrl) : null;

    if (!isEmpty(imageUrl)) {
      anchorRef.current?.click();
    }
  }


  const keyPhoto = type === PRIMARY_BANNER_TYPE ? BANNER_PRIMARY_PHOTO_FIELD_KEY :
                    type === SECONDARY_BANNER_TYPE ? BANNER_SECONDARY_PHOTO_FIELD_KEY :
                    type === SEARCH_BANNER_TYPE ? BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY : null;
        
  const image = keyPhoto ? getPreferenceFileUrlFromAccount(account, keyPhoto) : null;

  if (!image) {
    return null;
  }

  const keyPhotoUrl = type === PRIMARY_BANNER_TYPE ? BANNER_PRIMARY_PHOTO_URL_FIELD_KEY :
                      type === SECONDARY_BANNER_TYPE ? BANNER_SECONDARY_PHOTO_URL_FIELD_KEY :
                      type === SEARCH_BANNER_TYPE ? BANNER_SEARCH_RESULT_PHOTO_URL_FIELD_KEY : null;

  const imageUrl = keyPhotoUrl ? getPreferenceFromAccount(account, keyPhotoUrl) : null;

  return (
    <div className={`banner ${type === SEARCH_BANNER_TYPE ? 'search-result' : ''}`} onClick={handleClick} style={{ cursor: !isEmpty(imageUrl)? 'pointer' : 'auto'}}>
      <img src={image} alt="" width="100%" />
      {!isEmpty(imageUrl) && (<a href={imageUrl} target="_blank" rel="noreferrer" style={{ display: 'none'}} ref={anchorRef} />)}
    </div>
  );
}
